<template>
  <div class="container general-section">

    <h1>
      <font-awesome-icon icon="search" />
      Sökningar
    </h1>

    <test-data-hint />

    <div v-if="loaded">
      <div class="mb-1">
        <small class="text-muted">
          Total: {{ pagination.total }}
        </small>
      </div>
      <table class="table table-hover table-striped">
        <thead>
        <tr>
          <th>
            Datum
          </th>
          <th>
            Avtalstyp
          </th>
          <th>
            Postnummer
          </th>
          <th>
            Elförbrukning
          </th>
          <th>
            IP-adress
          </th>
        </tr>
        </thead>

        <template v-if="searches.length > 0">
          <tbody>
            <search-item v-for="search in searches" :search="search" :key="search.uuid" />
          </tbody>
        </template>

        <tbody v-else>
          <tr>
            <td colspan="7" class="text-center text-muted">
              <translate>Du har för naärvarande inga sökningar</translate>
            </td>
          </tr>
        </tbody>

      </table>
    </div>

    <contents-loader text="Laddar sökningar..." v-else></contents-loader>

    <pagination :pagination="pagination" :next="next"></pagination>

  </div>
</template>

<script>

  import {mapState} from "vuex"
  import Pagination from "./../../Partials/Pagination"
  import SearchItem from "./Partials/SearchItem"
  import ContentsLoader from "../../Partials/Loader/Contents"
  import TestDataHint from "../../Partials/TestData"

  export default {
    name: "Searches",
    components: {TestDataHint, ContentsLoader, SearchItem, Pagination},
    computed: {
      ...mapState({
        loaded: state => state.searches.loaded,
        searches: state => state.searches.collection,
        pagination: state => state.searches.pagination,
        affiliate: state => state.auth.affiliate,
      })
    },
    async mounted() {
      if(this.affiliate.earnings_mode !== 'search'){
        return this.$router.push({name: 'dashboard'})
      }

      await this.get()
    },
    destroyed() {
      /**
       * When instance is destroyed (aka user navigated to other page), we need to truncate orders in store,
       * so that on new page load they are extracted from scratch
       */
      this.$store.commit('searches/truncate')
    },
    methods: {
      async next() {
        await this.get(this.pagination.current_page + 1)
      },
      async get(page = null){
        let input = {
          filter: {
            status: 'completed',
          }
        }

        if(page !== null){
          input.page = page
        }

        await this.$store.dispatch('searches/fetch', input)
      }
    },
    metaInfo() {
      return {
        title: 'Sökningar'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Dashboard/Searches/Collection.vue